import React, { useState, useEffect } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material'; 

const TwoState = ({
  stateIconTrue: StateIconTrue = ExpandLess,
  stateIconFalse: StateIconFalse = ExpandMore,
  stateCallBack,
  initialState,
  nameKey,
  label = '' // You can pass a label prop
}) => {
  const [currentState, setCurrentState] = useState(initialState);

  const toggleState = () => {
    localStorage.setItem(nameKey, JSON.stringify(!currentState));
    setCurrentState(!currentState);
    if (stateCallBack) {
      stateCallBack(!currentState);
    }
  };

  useEffect(() => {
    if (nameKey) {
      let storedState = JSON.parse(localStorage.getItem(nameKey));
      if (storedState === null) {
        storedState = initialState;
      }
      setCurrentState(storedState);
      if (stateCallBack) {
        stateCallBack(storedState);
      }
    }
  }, [initialState, nameKey, stateCallBack]);

  return (
    <Box 
      display="flex" 
      alignItems="center" 
      sx={{ 
        // Reduce vertical space by adjusting line heights, margins, etc.
        lineHeight: 1, 
        padding: 0.5, 
        ml:1,
      }}
    >
      {label && (
        <Typography 
          variant="body2" 
          sx={{ mr: 1 }} // add a small right margin before the icon
        >
          {label}
        </Typography>
      )}
      <IconButton 
        onClick={toggleState} 
        size="small" // smaller button size
        sx={{ padding: 0.5 }} // adjust padding as needed
      >
        {currentState ? <StateIconTrue /> : <StateIconFalse />}
      </IconButton>
    </Box>
  );
};

export default TwoState;
